import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/lib/api-client'

export function useRemoveMember() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (memberId: string) =>
      apiClient.delete<void>(`/api/v1/households/members/${memberId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['household', 'members'] })
    },
  })
}
